import * as fuzzball from 'fuzzball';
import KEYWORDS from './keywords.json';

export function find(keyword) {
  const threshold = 0.64; // Adjust the threshold as needed

  const order = {};
  const matchedKeywords = Object.keys(KEYWORDS).filter((key) => {
    const score = fuzzball.ratio(keyword?.toLowerCase() ?? '', key.toLowerCase());
    order[key] = score;
    return score >= threshold * 100;
  });

  // Sort the matchedKeywords array based on the score in descending order
  matchedKeywords.sort((a, b) => order[b] - order[a]);

  return matchedKeywords.map((key) => ({ id: key, ...KEYWORDS[key] }));
}
